import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "name", label: "Organization Name" },
	{ key: "website", label: "Website" },
	{ key: "phoneNumber", label: "Business Phone" },
	{ key: "extension", label: "Extension" },
	{ key: "fax", label: "Fax" },
	{ key: "street", label: "Street" },
	{ key: "city", label: " City" },
	{ key: "state", label: "State" },
	{ key: "zipCode", label: "Zip Code" },
	{ key: "overseaAddress", label: "Oversea Address" },
	{ key: "background", label: "Background" },
	{ key: "voidReason", label: "Void Reason" }, 
	{ key: "validateReason", label: "Validate Reason" }, 
	{ key: "creatorId", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
];

export default function OrganizationExportForm(){
	return <ExportForm columns = {EXPORT_COLUMNS}/>;
}